import { API_CONFIG } from '../config/api';

export interface SignupData {
  username: string;
  password: string;
  email: string;
  role: string;
}

export interface LoginData {
  username: string;
  password: string;
}

export interface AuthResponse {
  status: 'success' | 'error';
  message?: string;
  results?: any[];
}

class AuthService {
  private baseUrl = API_CONFIG.AUTH.BASE_URL;
  private model = API_CONFIG.AUTH.MODEL;

  async signup(userData: SignupData): Promise<AuthResponse> {
    try {
      const response = await fetch(this.baseUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          action: 'signup',
          model: this.model,
          data: userData
        })
      });

      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Signup error:', error);
      return {
        status: 'error',
        message: 'An error occurred during registration. Please try again.'
      };
    }
  }

  async login(loginData: LoginData): Promise<AuthResponse> {
    try {
      const criteria = {
        "username": { "equal": loginData.username },
        "password": { "equal": loginData.password }
      };

      const response = await fetch(this.baseUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          action: 'login',
          model: this.model,
          criteria: criteria,
          driver: 'sqlite'
        })
      });

      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Login error:', error);
      return {
        status: 'error',
        message: 'An error occurred. Please try again.'
      };
    }
  }

  setToken(token: string): void {
    localStorage.setItem('token', token);
  }

  getToken(): string | null {
    return localStorage.getItem('token');
  }

  removeToken(): void {
    localStorage.removeItem('token');
  }

  isAuthenticated(): boolean {
    return !!this.getToken();
  }

  logout(): void {
    this.removeToken();
  }
}

export const authService = new AuthService();
